import { createFileRoute } from "@tanstack/react-router";

import { ArchivedSettings } from "../components/settings/ArchivedSettings";

export const Route = createFileRoute("/settings/archived")({
  component: ArchivedSettings,
});
